/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { PainelAcessos, PerfisAcesso, AplicarExcecoesEmGrupo } from "./Acessos";

export const CAMPOS_REDES = [
  { k: "link_google_reviews", icon: "⭐", l: "Google Reviews", ph: "https://g.page/r/..." },
  { k: "link_facebook", icon: "👍", l: "Facebook", ph: "https://facebook.com/..." },
  { k: "link_instagram", icon: "📸", l: "Instagram", ph: "https://instagram.com/..." },
  { k: "link_linkedin", icon: "💼", l: "LinkedIn", ph: "https://linkedin.com/in/..." },
  { k: "link_idealista", icon: "🏠", l: "Idealista", ph: "https://idealista.pt/agente/..." },
  { k: "link_tiktok", icon: "🎵", l: "TikTok", ph: "https://tiktok.com/@..." },
];
const REDES_VAZIAS = Object.fromEntries(CAMPOS_REDES.map(r => [r.k, ""]));

function getInitials(nome) {
  if (!nome) return "?";
  return nome.split(" ").map(n => n[0]).join("").substring(0, 2).toUpperCase();
}

function formatCurrency(v) {
  return Number(v).toLocaleString("pt-PT", { style: "currency", currency: "EUR" });
}

function daysSince(data) {
  if (!data) return 999;
  return Math.floor((Date.now() - new Date(data).getTime()) / 86400000);
}

const PAPEL_LABELS = {
  lider: "Líder",
  admin: "Admin",
  consultor: "Consultor",
  coordenadora: "Coordenadora",
  coordenadora_financeira: "Coordenadora Financeira",
  coordenadora_processual: "Coordenadora Processual",
  gestora_financeira: "Gestora Financeira",
  gestora_processual: "Gestora Processual",
  broker: "Broker",
  juridico: "Jurídico",
  marketing: "Marketing",
  recrutamento: "Recrutamento",
  staff: "Staff",
};
const papelLabel = p => PAPEL_LABELS[p] || p || "—";

// Suspender / reativar / arquivar / restaurar passa pelo servidor, que também
// bloqueia (ou desbloqueia) o login da pessoa no Supabase.
async function mudarEstadoConta(supabase, id, acao) {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    const r = await fetch("/api/estado-conta", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": `Bearer ${session?.access_token || ""}` },
      body: JSON.stringify({ id, acao }),
    });
    const d = await r.json().catch(() => ({}));
    if (!r.ok) { alert("Erro: " + (d.error || "desconhecido")); return false; }
    return true;
  } catch (e) {
    alert("Erro de ligação ao servidor.");
    return false;
  }
}
const PAPEL_OPCOES = ["consultor", "lider", "admin", "coordenadora_financeira", "coordenadora_processual", "gestora_financeira", "gestora_processual", "broker", "juridico", "marketing", "recrutamento"];

// Estado de cada conta — mutuamente exclusivo. Ordem de prioridade:
// eliminado > suspenso > a aguardar aprovação > acesso pendente > ativo.
function estadoDe(c) {
  if (c.arquivado_em) return { key: "eliminado", label: "Eliminado", cor: "#6b7280", bg: "#f3f4f6" };
  if (c.suspenso) return { key: "suspenso", label: "Suspenso", cor: "#f97316", bg: "#fff7ed" };
  if (c.aprovado === false) return { key: "pendente", label: "A aguardar aprovação", cor: "#ef4444", bg: "#fef2f2" };
  if (c.acesso_enviado !== true) return { key: "acesso_pendente", label: "Acesso pendente", cor: "#f59e0b", bg: "#fffbeb" };
  return { key: "ativo", label: "Ativo", cor: "#16a34a", bg: "#f0fdf4" };
}

function EstadoChip({ c }) {
  const e = estadoDe(c);
  return <span style={{ background: e.bg, color: e.cor, border: `1px solid ${e.cor}33`, borderRadius: 20, padding: "2px 9px", fontSize: 10.5, fontWeight: 700, whiteSpace: "nowrap" }}>{e.label}</span>;
}

function CardConsultor({ c, leads, negocios = [], supabase, profile, onRefresh, showNotif, onEliminar, onEditar, notaAdmin, onNotasGuardadas, selecionado, onSelecionar }) {
  const [expandido, setExpandido] = useState(false);
  const [notas, setNotas] = useState(notaAdmin || "");
  useEffect(() => { setNotas(notaAdmin || ""); }, [notaAdmin]);
  const [saving, setSaving] = useState(false);
  // Redes sociais: tabela perfil_redes (só o próprio e líder/admin leem — ver docs/sql/etapa3)
  const [redes, setRedes] = useState({ ...REDES_VAZIAS });
  useEffect(() => {
    if (!expandido) return;
    supabase.from("perfil_redes").select("*").eq("id", c.id).maybeSingle().then(({ data }) => {
      const r = { ...REDES_VAZIAS };
      Object.keys(r).forEach(k => { r[k] = data?.[k] || ""; });
      setRedes(r);
    });
  }, [expandido, c.id]);
  const [savingRedes, setSavingRedes] = useState(false);
  const guardarRedes = async () => {
    setSavingRedes(true);
    const { error } = await supabase.from("perfil_redes").upsert({ id: c.id, ...redes, updated_at: new Date().toISOString() });
    setSavingRedes(false);
    showNotif(error ? "Erro ao guardar redes: " + error.message : "Redes sociais guardadas.");
  };
  const numRedesPreenchidas = Object.values(redes).filter(Boolean).length;

  const cLeads = leads.filter(l => l.consultor_id === c.id);
  // Concluídos e 💰 contam NEGÓCIOS concluídos (vendidos/arrendados) em que participa —
  // o contacto não fica marcado "fechado" quando o negócio conclui.
  const negConcluidos = negocios.filter(n => !n.deleted_at && ["vendido","escriturado","arrendado"].includes(n.estado) && (n.consultor_ang_id === c.id || n.consultor_venda_id === c.id));
  const fechados = negConcluidos.length;
  const ativos = cLeads.filter(l => !["fechado","perdido"].includes(l.estado)).length;
  const perdidos = cLeads.filter(l => l.estado === "perdido").length;
  const valor = negConcluidos.reduce((a, n) => a + Number(n.valor_venda || 0), 0);
  const alertas = cLeads.filter(l => !["fechado","perdido"].includes(l.estado) && daysSince(l.ultimo_contacto) >= 3).length;

  const proprioPerfil = c.id === profile?.id;

  async function suspender() {
    if (!window.confirm(`Suspender acesso de ${c.nome}? Pode ser reativado a qualquer momento.`)) return;
    if (!(await mudarEstadoConta(supabase, c.id, "suspender"))) return;
    showNotif(`${c.nome} suspenso.`);
    onRefresh();
  }

  async function enviarReset() {
    const { error } = await supabase.auth.resetPasswordForEmail(c.email, { redirectTo: window.location.origin });
    if (!error) showNotif(`Email de recuperação enviado para ${c.email}`);
    else alert("Erro: " + error.message);
  }

  async function guardarNotas() {
    setSaving(true);
    // Notas guardadas numa tabela só acessível à líder/admin
    const { error } = await supabase.from("notas_admin_perfil").upsert({
      profile_id: c.id, notas, atualizado_em: new Date().toISOString(), atualizado_por: profile?.id || null,
    });
    setSaving(false);
    if (error) { alert("Erro a guardar notas: " + error.message); return; }
    showNotif("Notas guardadas.");
    if (onNotasGuardadas) onNotasGuardadas();
  }

  return (
    <div className="card" style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
        {onSelecionar && c.id !== profile?.id && (
          <input type="checkbox" checked={!!selecionado} onChange={() => onSelecionar(c.id)} title="Selecionar para ações em grupo" style={{ width: 17, height: 17, accentColor: "#0B1B3D", cursor: "pointer", flexShrink: 0 }} />
        )}
        <div className="avatar" style={{ width: 44, height: 44, fontSize: 15, background: "#1a1a2e", color: "#fff" }}>{getInitials(c.nome)}</div>
        <div style={{ flex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
            <span style={{ fontWeight: 700 }}>{c.nome}</span>
            {proprioPerfil && <span style={{ fontSize: 10, color: "#9ca3af" }}>(tu)</span>}
          </div>
          <div style={{ fontSize: 11.5, color: "#9ca3af" }}>{c.email}</div>
          <div style={{ display: "flex", alignItems: "center", gap: 5, marginTop: 4, flexWrap: "wrap" }}>
            <span style={{ background: "#eef2ff", color: "#6366f1", borderRadius: 20, padding: "2px 9px", fontSize: 10.5, fontWeight: 700 }}>{papelLabel(c.papel)}</span>
            <EstadoChip c={c} />
          </div>
        </div>
        {alertas > 0 && <span title="Contactos ativos sem contacto há 3 dias ou mais" style={{ background: "#fef2f2", color: "#ef4444", borderRadius: 20, padding: "2px 8px", fontSize: 11, fontWeight: 700 }}>⚠️ {alertas}</span>}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 6, textAlign: "center", marginBottom: 12 }}>
        {[["Total", cLeads.length, "#6366f1", "#eef2ff", "Contactos atribuídos a este consultor"], ["Ativos", ativos, "#3b82f6", "#eff6ff", "Contactos em curso (nem fechados nem perdidos)"], ["Concluídos", fechados, "#10b981", "#ecfdf5", "Negócios vendidos ou arrendados em que participou"], ["Perdidos", perdidos, "#ef4444", "#fef2f2", "Contactos marcados como perdidos"]].map(([l, v, col, bg, dica]) => (
          <div key={l} title={dica} style={{ background: bg, borderRadius: 8, padding: "7px 4px", cursor: "help" }}>
            <div style={{ fontWeight: 800, fontSize: 17, color: col }}>{v}</div>
            <div style={{ fontSize: 10, color: "#9ca3af" }}>{l}</div>
          </div>
        ))}
      </div>

      {valor > 0 && <div title="Valor de venda dos negócios concluídos" style={{ marginBottom: 10, background: "#f0fdf4", borderRadius: 8, padding: "7px 10px", textAlign: "center", fontSize: 12.5, color: "#10b981", fontWeight: 700 }}>💰 {formatCurrency(valor)}</div>}

      {notaAdmin && !expandido && (
        <div style={{ marginBottom: 8, fontSize: 12, color: "#6b7280", background: "#f8f7f4", borderRadius: 8, padding: "6px 10px" }}>
          📝 {notaAdmin.substring(0, 60)}{notaAdmin.length > 60 ? "..." : ""}
        </div>
      )}

      <button onClick={() => setExpandido(!expandido)} style={{ background: "none", border: "none", fontSize: 12, color: "#9ca3af", cursor: "pointer", textAlign: "left", padding: "2px 0" }}>
        {expandido ? "▲ Fechar" : "▼ Gerir"}
      </button>

      {expandido && (
        <div style={{ marginTop: 10, borderTop: "1px solid #f3f4f6", paddingTop: 12, display: "flex", flexDirection: "column", gap: 10 }}>
          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={() => onEditar(c)} style={{ flex: 1, background: "#f5f3ff", color: "#7c3aed", border: "1.5px solid #ddd6fe", borderRadius: 8, padding: "7px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
              ✏️ Editar
            </button>
            <button onClick={enviarReset} style={{ flex: 1, background: "#eff6ff", color: "#3b82f6", border: "1.5px solid #bfdbfe", borderRadius: 8, padding: "7px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
              🔑 Recuperar Password
            </button>
            {!proprioPerfil && (
              <>
                <button onClick={suspender} style={{ flex: 1, background: "#fef2f2", color: "#ef4444", border: "1.5px solid #fecaca", borderRadius: 8, padding: "7px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
                  🚫 Suspender
                </button>
                <button onClick={() => onEliminar(c)} style={{ flex: 1, background: "#f8f7f4", color: "#6b7280", border: "1.5px solid #ece9e3", borderRadius: 8, padding: "7px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
                  🗑 Eliminar
                </button>
              </>
            )}
          </div>
          {proprioPerfil && <div style={{ fontSize: 10.5, color: "#9ca3af" }}>ⓘ Não podes suspender ou eliminar a tua própria conta.</div>}
          <div>
            <div style={{ fontSize: 11, fontWeight: 600, color: "#6b7280", marginBottom: 4, textTransform: "uppercase", letterSpacing: "0.04em" }}>Notas internas</div>
            <textarea
              value={notas}
              onChange={e => setNotas(e.target.value)}
              rows={2}
              style={{ width: "100%", padding: "7px 10px", border: "1.5px solid #ece9e3", borderRadius: 8, fontSize: 12.5, fontFamily: "inherit", resize: "vertical", outline: "none" }}
              placeholder="Notas sobre este consultor..."
            />
            <button onClick={guardarNotas} disabled={saving} style={{ marginTop: 6, background: "#1a1a2e", color: "#fff", border: "none", borderRadius: 7, padding: "6px 14px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
              {saving ? "A guardar..." : "Guardar notas"}
            </button>
          </div>
          <div style={{ borderTop: "1px solid #f3f4f6", paddingTop: 12 }}>
            <div style={{ fontSize: 11, fontWeight: 600, color: "#6b7280", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.04em" }}>🔐 Acessos</div>
            <PainelAcessos supabase={supabase} pessoa={c} profile={profile} showNotif={showNotif} />
          </div>
          <div style={{ borderTop: "1px solid #f3f4f6", paddingTop: 12 }}>
            <div style={{ fontSize: 11, fontWeight: 600, color: "#6b7280", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.04em", display:"flex", justifyContent:"space-between" }}>
              <span>🌐 Redes Sociais Profissionais</span>
              <span style={{ color: numRedesPreenchidas>0?"#16a34a":"#9ca3af", fontWeight:700 }}>{numRedesPreenchidas}/{CAMPOS_REDES.length} preenchidas</span>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              {CAMPOS_REDES.map(r => (
                <div key={r.k} style={{ display:"flex", alignItems:"center", gap:6 }}>
                  <span title={r.l} style={{ fontSize:14, width:24, textAlign:"center" }}>{r.icon}</span>
                  <input
                    value={redes[r.k]}
                    onChange={e => setRedes(p => ({ ...p, [r.k]: e.target.value }))}
                    placeholder={r.ph}
                    style={{ flex:1, padding:"6px 9px", border:"1.5px solid #ece9e3", borderRadius:7, fontSize:12, fontFamily:"inherit", outline:"none" }}
                  />
                  {redes[r.k] && <a href={redes[r.k]} target="_blank" rel="noreferrer" title="Abrir" style={{ background:"#f0fdf4", color:"#16a34a", border:"1px solid #bbf7d0", borderRadius:5, padding:"4px 7px", textDecoration:"none", fontSize:11, fontWeight:700 }}>↗</a>}
                </div>
              ))}
            </div>
            <button onClick={guardarRedes} disabled={savingRedes} style={{ marginTop: 8, background: "#1a1a2e", color: "#fff", border: "none", borderRadius: 7, padding: "6px 14px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
              {savingRedes ? "A guardar..." : "🌐 Guardar redes"}
            </button>
            <div style={{ fontSize:10.5, color:"#9ca3af", marginTop:6, lineHeight:1.5 }}>
              ⓘ Estas redes aparecem no formulário de satisfação que o cliente preenche, para também poder deixar avaliação pública.
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default function ModuloConsultores({ supabase, profile, leads, negocios = [], consultores, fetchConsultores, showNotif }) {
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ nome: "", email: "", telefone: "", papel: "consultor" });
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState("");

  const [editando, setEditando] = useState(null);
  const [editForm, setEditForm] = useState({ nome: "", email: "", telefone: "", papel: "consultor" });
  const [editLoading, setEditLoading] = useState(false);
  const [editErro, setEditErro] = useState("");

  // ── Perfis de acesso e ações em grupo ──
  const [mostrarPerfis, setMostrarPerfis] = useState(false);
  const [selecionados, setSelecionados] = useState(() => new Set());
  const [showExcecoesGrupo, setShowExcecoesGrupo] = useState(false);
  const [emLote, setEmLote] = useState(false);
  const alternarSel = (id) => setSelecionados(sel => { const n = new Set(sel); if (n.has(id)) n.delete(id); else n.add(id); return n; });
  const pessoasSel = consultores.filter(c => selecionados.has(c.id) && c.id !== profile?.id);
  const nomes = arr => arr.map(p => "• " + p.nome).join("\n");

  async function loteRecuperarPassword() {
    if (!window.confirm(`Enviar email de recuperação de password a ${pessoasSel.length} pessoa(s)?\n\n${nomes(pessoasSel)}`)) return;
    setEmLote(true); let ok = 0;
    for (const c of pessoasSel) { const { error } = await supabase.auth.resetPasswordForEmail(c.email, { redirectTo: window.location.origin }); if (!error) ok++; }
    setEmLote(false); showNotif(`Email de recuperação enviado a ${ok} de ${pessoasSel.length}.`);
  }
  async function loteEstado(acao) {
    const alvo = pessoasSel.filter(c => acao === "suspender" ? !c.suspenso : c.suspenso);
    if (alvo.length === 0) { alert(acao === "suspender" ? "Nenhuma das pessoas selecionadas está ativa." : "Nenhuma das pessoas selecionadas está suspensa."); return; }
    if (!window.confirm(`${acao === "suspender" ? "Suspender" : "Reativar"} ${alvo.length} pessoa(s)?\n\n${nomes(alvo)}`)) return;
    setEmLote(true); let ok = 0;
    for (const c of alvo) { if (await mudarEstadoConta(supabase, c.id, acao)) ok++; }
    setEmLote(false); setSelecionados(new Set()); fetchConsultores();
    showNotif(`${ok} de ${alvo.length} ${acao === "suspender" ? "suspensos" : "reativados"}.`);
  }
  async function loteEliminar() {
    if (!window.confirm(`Eliminar ${pessoasSel.length} pessoa(s)?\n\n${nomes(pessoasSel)}\n\nVou verificar primeiro quem tem histórico associado.`)) return;
    setEmLote(true);
    const { data: { session } } = await supabase.auth.getSession();
    const headers = { "Content-Type": "application/json", "Authorization": `Bearer ${session?.access_token || ""}` };
    const semHist = [], comHist = [];
    for (const c of pessoasSel) {
      const r = await fetch("/api/delete-user", { method: "POST", headers, body: JSON.stringify({ id: c.id, dryRun: true }) });
      if (r.ok) semHist.push(c); else if (r.status === 409) comHist.push(c);
    }
    let apagados = 0, arquivados = 0;
    if (semHist.length && window.confirm(`Sem histórico — ELIMINAR DEFINITIVAMENTE (não há como desfazer):\n\n${nomes(semHist)}\n\nTens a certeza?`)) {
      for (const c of semHist) { const r = await fetch("/api/delete-user", { method: "POST", headers, body: JSON.stringify({ id: c.id }) }); if (r.ok) apagados++; }
    }
    const aArquivar = comHist.filter(c => !c.arquivado_em);
    if (aArquivar.length && window.confirm(`Com histórico — não podem ser eliminados. Arquivar em vez disso (ficam sem acesso, histórico mantém-se)?\n\n${nomes(aArquivar)}`)) {
      for (const c of aArquivar) { if (await mudarEstadoConta(supabase, c.id, "arquivar")) arquivados++; }
    }
    setEmLote(false); setSelecionados(new Set()); fetchConsultores();
    showNotif(`${apagados} eliminado(s), ${arquivados} arquivado(s).`);
  }

  // Notas da líder sobre cada pessoa (tabela notas_admin_perfil — só líder/admin lêem)
  const [notasAdmin, setNotasAdmin] = useState({});
  const fetchNotasAdmin = async () => {
    const { data } = await supabase.from("notas_admin_perfil").select("profile_id, notas");
    const m = {}; (data || []).forEach(r => { m[r.profile_id] = r.notas; });
    setNotasAdmin(m);
  };
  useEffect(() => { fetchNotasAdmin(); }, []);

  function abrirEdicao(c) {
    setEditando(c);
    setEditForm({ nome: c.nome || "", email: c.email || "", telefone: c.telefone || "", papel: c.papel || "consultor" });
    setEditErro("");
  }

  async function guardarEdicao() {
    setEditErro("");
    if (!editForm.nome || !editForm.email || !editForm.papel) {
      setEditErro("Nome, email e papel são obrigatórios.");
      return;
    }
    const emailMudou = editForm.email.trim().toLowerCase() !== (editando.email || "").trim().toLowerCase();
    setEditLoading(true);
    try {
      const { data: { session } } = await supabase.auth.getSession();
      const res = await fetch("/api/update-user", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${session?.access_token || ""}` },
        body: JSON.stringify({ id: editando.id, ...editForm })
      });
      const data = await res.json();
      if (!res.ok) {
        setEditErro(data.error || "Erro ao guardar alterações.");
        setEditLoading(false);
        return;
      }
      // Email mudou: manda logo um link para a pessoa definir password nova nesse email.
      if (emailMudou) {
        const { error } = await supabase.auth.resetPasswordForEmail(editForm.email, { redirectTo: window.location.origin });
        if (error) showNotif(`Email atualizado, mas falhou enviar o link de password: ${error.message}`);
        else showNotif(`${editForm.nome} atualizado — link de nova password enviado para ${editForm.email}.`);
      } else {
        showNotif(`${editForm.nome} atualizado.`);
      }
      setEditando(null);
      fetchConsultores();
    } catch (e) {
      setEditErro("Erro de ligação ao servidor.");
    }
    setEditLoading(false);
  }

  async function aprovar(c) {
    await supabase.from("profiles").update({
      aprovado: true,
      aprovado_em: new Date().toISOString(),
      aprovado_por: profile?.nome || "",
    }).eq("id", c.id);
    showNotif(`${c.nome} aprovado.`);
    fetchConsultores();
  }

  async function enviarResetPendente(c) {
    const { error } = await supabase.auth.resetPasswordForEmail(c.email, { redirectTo: window.location.origin });
    if (!error) showNotif(`Email de recuperação enviado para ${c.email}`);
    else alert("Erro: " + error.message);
  }

  async function criarMembro() {
    setErro("");
    if (!form.nome || !form.email || !form.papel) {
      setErro("Nome, email e papel são obrigatórios.");
      return;
    }
    setLoading(true);
    try {
      const { data: { session } } = await supabase.auth.getSession();
      const res = await fetch("/api/create-user", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${session?.access_token || ""}`
        },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (!res.ok) {
        setErro(data.error || "Erro ao criar membro.");
        setLoading(false);
        return;
      }
      await supabase.from("profiles").update({ acesso_enviado: false }).eq("id", data.id);
      setShowModal(false);
      setForm({ nome: "", email: "", telefone: "", papel: "consultor" });
      fetchConsultores();
      showNotif(`${form.nome} adicionado com sucesso.`);
    } catch (e) {
      setErro("Erro de ligação ao servidor.");
    }
    setLoading(false);
  }

  async function enviarAcesso(membro) {
    const { error } = await supabase.auth.resetPasswordForEmail(membro.email, { redirectTo: window.location.origin });
    if (!error) {
      await supabase.from("profiles").update({ acesso_enviado: true }).eq("id", membro.id);
      showNotif(`Email de acesso enviado para ${membro.email}`);
      fetchConsultores();
    } else alert("Erro: " + error.message);
  }

  async function reativar(c) {
    if (!(await mudarEstadoConta(supabase, c.id, "reativar"))) return;
    showNotif(`${c.nome} reativado.`);
    fetchConsultores();
  }

  async function restaurar(c) {
    if (!(await mudarEstadoConta(supabase, c.id, "restaurar"))) return;
    showNotif(`${c.nome} restaurado.`);
    fetchConsultores();
  }

  // Elimina, sempre a confirmar em cada passo:
  // 1) confirma a intenção de eliminar
  // 2) verifica no servidor (sem apagar nada ainda) se há histórico associado
  // 3a) se houver histórico → oferece arquivar em alternativa (com confirmação própria)
  // 3b) se não houver nada → avisa explicitamente que vai ser DEFINITIVO e pede confirmação final antes de apagar a sério
  async function eliminarConsultor(c) {
    if (c.id === profile?.id) { alert("Não podes eliminar a tua própria conta."); return; }
    if (!window.confirm(`Eliminar ${c.nome}?\n\nVou verificar primeiro se tem histórico associado (leads, negócios, angariações, etc.) antes de fazer seja o que for.`)) return;
    try {
      const { data: { session } } = await supabase.auth.getSession();
      const headers = { "Content-Type": "application/json", "Authorization": `Bearer ${session?.access_token || ""}` };

      const checkRes = await fetch("/api/delete-user", { method: "POST", headers, body: JSON.stringify({ id: c.id, dryRun: true }) });
      const checkData = await checkRes.json();

      if (!checkRes.ok) {
        if (checkRes.status === 409 && !c.arquivado_em) {
          if (window.confirm(`${checkData.error}\n\nQueres arquivar em vez disso? Fica sem acesso à app, mas o histórico mantém-se, e podes restaurar depois.`)) {
            if (!(await mudarEstadoConta(supabase, c.id, "arquivar"))) return;
            showNotif(`${c.nome} arquivado.`);
            fetchConsultores();
          }
        } else {
          alert("Erro: " + (checkData.error || "desconhecido"));
        }
        return;
      }

      // Confirmado: não tem nenhum histórico associado — última confirmação antes do passo irreversível.
      if (!window.confirm(`${c.nome} não tem nenhum histórico associado (sem leads, negócios, angariações, etc.).\n\nVou ELIMINAR DEFINITIVAMENTE esta conta (login + perfil) — não há como desfazer depois.\n\nTens a certeza?`)) return;

      const delRes = await fetch("/api/delete-user", { method: "POST", headers, body: JSON.stringify({ id: c.id }) });
      const delData = await delRes.json();
      if (delRes.ok) {
        showNotif(`${c.nome} eliminado definitivamente.`);
        fetchConsultores();
      } else {
        alert("Erro: " + (delData.error || "desconhecido"));
      }
    } catch (e) {
      alert("Erro de ligação ao servidor.");
    }
  }

  // Estados mutuamente exclusivos — cada conta aparece em exatamente um grupo.
  // Ordem de prioridade: eliminado > suspenso > a aguardar aprovação > acesso pendente > ativo.
  const ordenarNome = arr => [...arr].sort((a, b) => (a.nome || "").localeCompare(b.nome || "", "pt"));
  const eliminados = ordenarNome(consultores.filter(c => c.arquivado_em));
  const suspensos = ordenarNome(consultores.filter(c => !c.arquivado_em && c.suspenso));
  const pendentes = ordenarNome(consultores.filter(c => !c.arquivado_em && !c.suspenso && c.aprovado === false));
  const acessoPendente = ordenarNome(consultores.filter(c => !c.arquivado_em && !c.suspenso && c.aprovado !== false && c.acesso_enviado !== true));
  const ativos = ordenarNome(consultores.filter(c => !c.arquivado_em && !c.suspenso && c.aprovado !== false && c.acesso_enviado === true));

  return (
    <div>
      <div style={{ marginBottom: 22, display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
        <div>
          <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 26, fontWeight: 700 }}>Consultores</h1>
          <p style={{ color: "#9ca3af", marginTop: 3, fontSize: 13 }}>
            {ativos.length} membros da equipa ativos
            {pendentes.length > 0 && <span style={{ color: "#ef4444", fontWeight: 700 }}> · {pendentes.length} a aguardar aprovação</span>}
            {acessoPendente.length > 0 && <span style={{ color: "#f59e0b", fontWeight: 700 }}> · {acessoPendente.length} com acesso pendente</span>}
            {suspensos.length > 0 && <span style={{ color: "#f97316", fontWeight: 700 }}> · {suspensos.length} suspensos</span>}
          </p>
        </div>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: "flex-end" }}>
        <button onClick={() => setMostrarPerfis(v => !v)} style={{ background: mostrarPerfis ? "#0B1B3D" : "#fff", color: mostrarPerfis ? "#fff" : "#0B1B3D", border: "1.5px solid #0B1B3D", borderRadius: 10, padding: "10px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap" }}>
          🔐 Perfis de acesso
        </button>
        <button
          onClick={() => { setShowModal(true); setErro(""); }}
          style={{ background: "#1a1a2e", color: "#fff", border: "none", borderRadius: 10, padding: "10px 18px", fontSize: 13, fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap" }}
        >
          + Adicionar membro
        </button>
        </div>
      </div>

      {mostrarPerfis && <PerfisAcesso supabase={supabase} profile={profile} showNotif={showNotif} />}
      {showExcecoesGrupo && <AplicarExcecoesEmGrupo supabase={supabase} pessoas={pessoasSel} profile={profile} showNotif={showNotif} onClose={() => { setShowExcecoesGrupo(false); setSelecionados(new Set()); }} />}

      {/* A aguardar aprovação */}
      {pendentes.length > 0 && (
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#ef4444", marginBottom: 10 }}>⏳ A aguardar aprovação</div>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {pendentes.map(c => (
              <div key={c.id} style={{ background: "#fff", borderRadius: 12, border: "1.5px solid #fecaca", padding: "14px 18px", display: "flex", alignItems: "center", gap: 14 }}>
                <div style={{ width: 40, height: 40, fontSize: 14, background: "#ef4444", color: "#fff", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, flexShrink: 0 }}>
                  {getInitials(c.nome)}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: 14 }}>{c.nome}</div>
                  <div style={{ fontSize: 12, color: "#9ca3af" }}>{c.email}</div>
                  <div style={{ display: "flex", gap: 5, marginTop: 4 }}>
                    <span style={{ background: "#eef2ff", color: "#6366f1", borderRadius: 20, padding: "2px 9px", fontSize: 10.5, fontWeight: 700 }}>{papelLabel(c.papel)}</span>
                    <EstadoChip c={c} />
                  </div>
                </div>
                <button onClick={() => abrirEdicao(c)} style={{ background: "#f5f3ff", color: "#7c3aed", border: "1.5px solid #ddd6fe", borderRadius: 8, padding: "8px 14px", fontWeight: 600, fontSize: 12, cursor: "pointer" }}>
                  ✏️ Editar
                </button>
                <button onClick={() => aprovar(c)} style={{ background: "#10b981", color: "#fff", border: "none", borderRadius: 8, padding: "8px 16px", fontWeight: 600, fontSize: 12.5, cursor: "pointer" }}>
                  ✓ Aprovar
                </button>
                <button onClick={() => enviarResetPendente(c)} style={{ background: "#f8f7f4", color: "#6b7280", border: "1.5px solid #ece9e3", borderRadius: 8, padding: "8px 14px", fontWeight: 600, fontSize: 12, cursor: "pointer" }}>
                  🔑 Enviar Password
                </button>
                <button onClick={() => eliminarConsultor(c)} style={{ background: "#fff", color: "#9ca3af", border: "1.5px solid #ece9e3", borderRadius: 8, padding: "8px 14px", fontWeight: 600, fontSize: 12, cursor: "pointer" }}>
                  🗑 Eliminar
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Acesso pendente */}
      {acessoPendente.length > 0 && (
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#f59e0b", marginBottom: 10 }}>🕐 Acesso pendente</div>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {acessoPendente.map(m => (
              <div key={m.id} style={{ background: "#fff", borderRadius: 12, border: "1.5px solid #fde68a", padding: "14px 18px", display: "flex", alignItems: "center", gap: 14 }}>
                <div style={{ width: 40, height: 40, fontSize: 14, background: "#f59e0b", color: "#fff", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, flexShrink: 0 }}>
                  {getInitials(m.nome)}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: 14 }}>{m.nome}</div>
                  <div style={{ fontSize: 12, color: "#9ca3af" }}>{m.email}</div>
                  <div style={{ display: "flex", gap: 5, marginTop: 4 }}>
                    <span style={{ background: "#eef2ff", color: "#6366f1", borderRadius: 20, padding: "2px 9px", fontSize: 10.5, fontWeight: 700 }}>{papelLabel(m.papel)}</span>
                    <EstadoChip c={m} />
                  </div>
                </div>
                <button onClick={() => abrirEdicao(m)} style={{ background: "#f5f3ff", color: "#7c3aed", border: "1.5px solid #ddd6fe", borderRadius: 8, padding: "8px 14px", fontWeight: 600, fontSize: 12, cursor: "pointer" }}>
                  ✏️ Editar
                </button>
                <button onClick={() => enviarAcesso(m)} style={{ background: "#fffbeb", color: "#f59e0b", border: "1.5px solid #fde68a", borderRadius: 8, padding: "8px 14px", fontWeight: 600, fontSize: 12, cursor: "pointer" }}>
                  Enviar acesso
                </button>
                {m.id !== profile?.id && (
                  <button onClick={() => eliminarConsultor(m)} style={{ background: "#fff", color: "#9ca3af", border: "1.5px solid #ece9e3", borderRadius: 8, padding: "8px 14px", fontWeight: 600, fontSize: 12, cursor: "pointer" }}>
                    🗑 Eliminar
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Ativos */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, flexWrap: "wrap", marginBottom: 8 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: "#1a1a2e" }}>✅ Ativos</div>
        <div style={{ display: "flex", gap: 6, fontSize: 12 }}>
          <button onClick={() => setSelecionados(new Set(ativos.filter(c => c.id !== profile?.id).map(c => c.id)))} style={{ background: "#fff", border: "1.5px solid #ece9e3", borderRadius: 8, padding: "5px 10px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>☑ Selecionar todos</button>
          {selecionados.size > 0 && <button onClick={() => setSelecionados(new Set())} style={{ background: "#fff", border: "1.5px solid #ece9e3", borderRadius: 8, padding: "5px 10px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>Limpar seleção</button>}
        </div>
      </div>
      <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 10, lineHeight: 1.6 }}>
        <b>Total</b> contactos atribuídos · <b>Ativos</b> contactos em curso · <b>Concluídos</b> negócios vendidos/arrendados em que participou · <b>Perdidos</b> contactos perdidos · <b>⚠️</b> ativos sem contacto há 3+ dias · <b>💰</b> valor dos negócios concluídos
      </div>
      {pessoasSel.length > 0 && (
        <div style={{ position: "sticky", top: 8, zIndex: 20, background: "#0B1B3D", color: "#fff", borderRadius: 12, padding: "10px 14px", marginBottom: 12, display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
          <b style={{ fontSize: 13, marginRight: 6 }}>{pessoasSel.length} selecionado(s)</b>
          {[["🔐 Aplicar acessos iguais", () => setShowExcecoesGrupo(true)], ["🔑 Recuperar password", loteRecuperarPassword], ["🚫 Suspender", () => loteEstado("suspender")], ["↺ Reativar", () => loteEstado("reativar")], ["🗑 Eliminar", loteEliminar]].map(([l, fn]) => (
            <button key={l} disabled={emLote} onClick={fn} style={{ background: "rgba(255,255,255,0.12)", color: "#fff", border: "1px solid rgba(255,255,255,0.25)", borderRadius: 8, padding: "6px 11px", fontSize: 12, fontWeight: 600, cursor: emLote ? "wait" : "pointer" }}>{l}</button>
          ))}
          {emLote && <span style={{ fontSize: 12, opacity: 0.8 }}>A processar...</span>}
        </div>
      )}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 14, marginBottom: 24 }}>
        {ativos.map(c => (
          <CardConsultor
            key={c.id}
            c={c}
            leads={leads}
            negocios={negocios}
            selecionado={selecionados.has(c.id)}
            onSelecionar={alternarSel}
            supabase={supabase}
            profile={profile}
            onRefresh={fetchConsultores}
            showNotif={showNotif}
            onEliminar={eliminarConsultor}
            onEditar={abrirEdicao}
            notaAdmin={notasAdmin[c.id]}
            onNotasGuardadas={fetchNotasAdmin}
          />
        ))}
        {ativos.length === 0 && (
          <div style={{ gridColumn: "1/-1", textAlign: "center", padding: 40, color: "#9ca3af", background: "#fff", borderRadius: 14, border: "1px solid #ebebeb" }}>
            Os membros da equipa aparecerão aqui após criarem as suas contas.
          </div>
        )}
      </div>

      {/* Suspensos */}
      {suspensos.length > 0 && (
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#f97316", marginBottom: 10 }}>🚫 Suspensos</div>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {suspensos.map(c => (
              <div key={c.id} style={{ background: "#fff", borderRadius: 12, border: "1.5px solid #fed7aa", padding: "14px 18px", display: "flex", alignItems: "center", gap: 14 }}>
                <input type="checkbox" checked={selecionados.has(c.id)} onChange={() => alternarSel(c.id)} title="Selecionar para ações em grupo" style={{ width: 17, height: 17, accentColor: "#0B1B3D", cursor: "pointer" }} />
                <div style={{ width: 40, height: 40, fontSize: 14, background: "#f97316", color: "#fff", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, flexShrink: 0 }}>
                  {getInitials(c.nome)}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: 14 }}>{c.nome}</div>
                  <div style={{ fontSize: 12, color: "#9ca3af" }}>{c.email}</div>
                  <div style={{ display: "flex", gap: 5, marginTop: 4 }}>
                    <span style={{ background: "#eef2ff", color: "#6366f1", borderRadius: 20, padding: "2px 9px", fontSize: 10.5, fontWeight: 700 }}>{papelLabel(c.papel)}</span>
                    <EstadoChip c={c} />
                  </div>
                </div>
                <button onClick={() => abrirEdicao(c)} style={{ background: "#f5f3ff", color: "#7c3aed", border: "1.5px solid #ddd6fe", borderRadius: 8, padding: "8px 14px", fontWeight: 600, fontSize: 12, cursor: "pointer" }}>
                  ✏️ Editar
                </button>
                <button onClick={() => reativar(c)} style={{ background: "#f0fdf4", color: "#16a34a", border: "1.5px solid #bbf7d0", borderRadius: 8, padding: "8px 14px", fontWeight: 600, fontSize: 12, cursor: "pointer" }}>
                  ↺ Reativar
                </button>
                <button onClick={() => eliminarConsultor(c)} style={{ background: "#fff", color: "#9ca3af", border: "1.5px solid #ece9e3", borderRadius: 8, padding: "8px 14px", fontWeight: 600, fontSize: 12, cursor: "pointer" }}>
                  🗑 Eliminar
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Eliminados */}
      {eliminados.length > 0 && (
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#6b7280", marginBottom: 10 }}>🗑 Eliminados</div>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {eliminados.map(c => (
              <div key={c.id} style={{ background: "#faf9f7", borderRadius: 12, border: "1.5px solid #ece9e3", padding: "14px 18px", display: "flex", alignItems: "center", gap: 14, opacity: 0.75 }}>
                <div style={{ width: 40, height: 40, fontSize: 14, background: "#9ca3af", color: "#fff", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, flexShrink: 0 }}>
                  {getInitials(c.nome)}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: 14 }}>{c.nome}</div>
                  <div style={{ fontSize: 12, color: "#9ca3af" }}>{c.email} · eliminado em {new Date(c.arquivado_em).toLocaleDateString("pt-PT")}</div>
                  <div style={{ display: "flex", gap: 5, marginTop: 4 }}>
                    <span style={{ background: "#eef2ff", color: "#6366f1", borderRadius: 20, padding: "2px 9px", fontSize: 10.5, fontWeight: 700 }}>{papelLabel(c.papel)}</span>
                    <EstadoChip c={c} />
                  </div>
                </div>
                <button onClick={() => restaurar(c)} style={{ background: "#fff", color: "#6b7280", border: "1.5px solid #ece9e3", borderRadius: 8, padding: "8px 14px", fontWeight: 600, fontSize: 12, cursor: "pointer" }}>
                  ↺ Restaurar
                </button>
                <button onClick={() => eliminarConsultor(c)} style={{ background: "#fff", color: "#9ca3af", border: "1.5px solid #ece9e3", borderRadius: 8, padding: "8px 14px", fontWeight: 600, fontSize: 12, cursor: "pointer" }}>
                  🗑 Eliminar definitivamente
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Modal — Adicionar membro */}
      {showModal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "#fff", borderRadius: 18, padding: 36, width: 440, boxShadow: "0 24px 60px rgba(0,0,0,0.18)", fontFamily: "'DM Sans', sans-serif" }}>
            <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 20, fontWeight: 700, marginBottom: 6 }}>Adicionar membro</div>
            <div style={{ fontSize: 13, color: "#9ca3af", marginBottom: 24 }}>Será criada uma conta. O membro definirá a sua password via email.</div>

            {erro && (
              <div style={{ background: "#fef2f2", color: "#ef4444", borderRadius: 8, padding: "10px 14px", fontSize: 13, marginBottom: 16 }}>{erro}</div>
            )}

            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              <div>
                <label style={{ fontSize: 12, fontWeight: 600, color: "#6b7280", display: "block", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.04em" }}>Nome *</label>
                <input
                  type="text"
                  value={form.nome}
                  onChange={e => setForm(f => ({ ...f, nome: e.target.value }))}
                  placeholder="Nome completo"
                  style={{ background: "#f9fafb", border: "1.5px solid #e5e7eb", borderRadius: 10, padding: "11px 14px", fontSize: 14, width: "100%", outline: "none", fontFamily: "inherit", color: "#1a1a2e", boxSizing: "border-box" }}
                />
              </div>
              <div>
                <label style={{ fontSize: 12, fontWeight: 600, color: "#6b7280", display: "block", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.04em" }}>Email *</label>
                <input
                  type="text"
                  value={form.email}
                  onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
                  placeholder="email@exemplo.com"
                  style={{ background: "#f9fafb", border: "1.5px solid #e5e7eb", borderRadius: 10, padding: "11px 14px", fontSize: 14, width: "100%", outline: "none", fontFamily: "inherit", color: "#1a1a2e", boxSizing: "border-box" }}
                />
              </div>
              <div>
                <label style={{ fontSize: 12, fontWeight: 600, color: "#6b7280", display: "block", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.04em" }}>Telefone</label>
                <input
                  type="text"
                  value={form.telefone}
                  onChange={e => setForm(f => ({ ...f, telefone: e.target.value }))}
                  placeholder="+351 9xx xxx xxx"
                  style={{ background: "#f9fafb", border: "1.5px solid #e5e7eb", borderRadius: 10, padding: "11px 14px", fontSize: 14, width: "100%", outline: "none", fontFamily: "inherit", color: "#1a1a2e", boxSizing: "border-box" }}
                />
              </div>
              <div>
                <label style={{ fontSize: 12, fontWeight: 600, color: "#6b7280", display: "block", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.04em" }}>Papel *</label>
                <select
                  value={form.papel}
                  onChange={e => setForm(f => ({ ...f, papel: e.target.value }))}
                  style={{ background: "#f9fafb", border: "1.5px solid #e5e7eb", borderRadius: 10, padding: "11px 14px", fontSize: 14, width: "100%", outline: "none", fontFamily: "inherit", color: "#1a1a2e", boxSizing: "border-box" }}
                >
                  {PAPEL_OPCOES.map(p => <option key={p} value={p}>{papelLabel(p)}</option>)}
                </select>
              </div>
            </div>

            <div style={{ display: "flex", gap: 10, marginTop: 26 }}>
              <button
                onClick={() => { setShowModal(false); setErro(""); setForm({ nome: "", email: "", telefone: "", papel: "consultor" }); }}
                style={{ flex: 1, background: "#f3f4f6", color: "#374151", border: "none", borderRadius: 10, padding: "12px", fontSize: 14, fontWeight: 600, cursor: "pointer" }}
              >
                Cancelar
              </button>
              <button
                onClick={criarMembro}
                disabled={loading}
                style={{ flex: 1, background: "#1a1a2e", color: "#fff", border: "none", borderRadius: 10, padding: "12px", fontSize: 14, fontWeight: 600, cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1 }}
              >
                {loading ? "A criar..." : "Criar conta"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal — Editar perfil */}
      {editando && (() => {
        const emailMudou = editForm.email.trim().toLowerCase() !== (editando.email || "").trim().toLowerCase();
        return (
          <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div style={{ background: "#fff", borderRadius: 18, padding: 36, width: 440, boxShadow: "0 24px 60px rgba(0,0,0,0.18)", fontFamily: "'DM Sans', sans-serif" }}>
              <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 20, fontWeight: 700, marginBottom: 6 }}>Editar perfil</div>
              <div style={{ fontSize: 13, color: "#9ca3af", marginBottom: 24 }}>{editando.nome}</div>

              {editErro && (
                <div style={{ background: "#fef2f2", color: "#ef4444", borderRadius: 8, padding: "10px 14px", fontSize: 13, marginBottom: 16 }}>{editErro}</div>
              )}

              <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: "#6b7280", display: "block", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.04em" }}>Nome *</label>
                  <input
                    type="text"
                    value={editForm.nome}
                    onChange={e => setEditForm(f => ({ ...f, nome: e.target.value }))}
                    style={{ background: "#f9fafb", border: "1.5px solid #e5e7eb", borderRadius: 10, padding: "11px 14px", fontSize: 14, width: "100%", outline: "none", fontFamily: "inherit", color: "#1a1a2e", boxSizing: "border-box" }}
                  />
                </div>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: "#6b7280", display: "block", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.04em" }}>Email (login) *</label>
                  <input
                    type="text"
                    value={editForm.email}
                    onChange={e => setEditForm(f => ({ ...f, email: e.target.value }))}
                    style={{ background: "#f9fafb", border: "1.5px solid #e5e7eb", borderRadius: 10, padding: "11px 14px", fontSize: 14, width: "100%", outline: "none", fontFamily: "inherit", color: "#1a1a2e", boxSizing: "border-box" }}
                  />
                  {emailMudou && (
                    <div style={{ fontSize: 11, color: "#f59e0b", marginTop: 5, lineHeight: 1.5 }}>
                      ⚠️ Email diferente do atual ({editando.email}) — ao guardar, a conta passa a entrar com este email novo, e é enviado automaticamente um link para definir password nova nesse email.
                    </div>
                  )}
                </div>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: "#6b7280", display: "block", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.04em" }}>Telefone</label>
                  <input
                    type="text"
                    value={editForm.telefone}
                    onChange={e => setEditForm(f => ({ ...f, telefone: e.target.value }))}
                    style={{ background: "#f9fafb", border: "1.5px solid #e5e7eb", borderRadius: 10, padding: "11px 14px", fontSize: 14, width: "100%", outline: "none", fontFamily: "inherit", color: "#1a1a2e", boxSizing: "border-box" }}
                  />
                </div>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: "#6b7280", display: "block", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.04em" }}>Papel *</label>
                  <select
                    value={editForm.papel}
                    onChange={e => setEditForm(f => ({ ...f, papel: e.target.value }))}
                    style={{ background: "#f9fafb", border: "1.5px solid #e5e7eb", borderRadius: 10, padding: "11px 14px", fontSize: 14, width: "100%", outline: "none", fontFamily: "inherit", color: "#1a1a2e", boxSizing: "border-box" }}
                  >
                    {PAPEL_OPCOES.map(p => <option key={p} value={p}>{papelLabel(p)}</option>)}
                  </select>
                </div>
              </div>

              <div style={{ display: "flex", gap: 10, marginTop: 26 }}>
                <button
                  onClick={() => setEditando(null)}
                  style={{ flex: 1, background: "#f3f4f6", color: "#374151", border: "none", borderRadius: 10, padding: "12px", fontSize: 14, fontWeight: 600, cursor: "pointer" }}
                >
                  Cancelar
                </button>
                <button
                  onClick={guardarEdicao}
                  disabled={editLoading}
                  style={{ flex: 1, background: "#1a1a2e", color: "#fff", border: "none", borderRadius: 10, padding: "12px", fontSize: 14, fontWeight: 600, cursor: editLoading ? "not-allowed" : "pointer", opacity: editLoading ? 0.7 : 1 }}
                >
                  {editLoading ? "A guardar..." : "Guardar alterações"}
                </button>
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
}
